import { ACCOUNTS_API } from './accounts';
import { ADMIN_API } from './admin';
import { BILLING_API } from './billing';
import { CLIENT_STORAGE_API } from './clientStorage';
import { APP_SETTINGS_API } from './config';
import { CONTENT_API } from './content';
import { GLOSSARY_API } from './glossary';
import { LEAD_SURVEY_API } from './leadSurvey';
import { LIBRARY_CALLS_API } from './library';
import { NOTIFICATIONS_API } from './notifications';
import { OTHER_CALLS_API } from './otherCalls';
import { PROJECT_API } from './project';
import { RECORDING_API } from './recording';
import { SPACE_API } from './space';
import { SURVEY_API } from './survey';
import { USER_API } from './user';
import { VOICE_PRESETS_API } from './voicePreset';

export const API = {
  ...APP_SETTINGS_API,
  ...USER_API,
  ...BILLING_API,
  ...PROJECT_API,
  ...SURVEY_API,
  ...OTHER_CALLS_API,
  ...ADMIN_API,
  ...ACCOUNTS_API,
  ...VOICE_PRESETS_API,
  ...GLOSSARY_API,
  ...LIBRARY_CALLS_API,
  ...SPACE_API,
  ...NOTIFICATIONS_API,
  ...RECORDING_API,
  ...CLIENT_STORAGE_API,
  ...LEAD_SURVEY_API,
  ...CONTENT_API,
};
